(function () {
    'use strict';

    $.fn.isInViewport = function () {
        var elementTop = $(this).offset().top;
        var elementBottom = elementTop + $(this).outerHeight();

        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();

        return elementBottom > viewportTop && elementTop < viewportBottom;
    };

    $(window).on('resize scroll', function () {
        $('.homepage .section[data-section]').each(function () {
            var sectionId = $(this).data('section');
            if ($(this).isInViewport()) {
                $('.section-pager li a[data-target = ' + sectionId + ']').addClass('active');
                $('.section-pager li a[data-target = ' + sectionId + ']').parent().siblings().children().removeClass('active');
            }
        });
    });

    $(document).ready(function () {

        if (window.matchMedia("(min-width: 1025px)").matches) {
            var videoClasses = '.video-cover, .content, .play-video';
        } else {
            var videoClasses = '.video-cover, .content .play-video';
        }

        $('.homepage .section-home').find(videoClasses).on('click', function (e) {
            e.preventDefault();
            var sectionHome = $(this).closest('.section-home');
            var video = $(this).closest('.section-home').find('video')[0];

            if (video.paused) {
                sectionHome.addClass('play');
                video.play();
            } else {
                sectionHome.removeClass('play');
                video.pause();
            }
        });

        if (window.matchMedia("(min-width: 1025px)").matches) {
            setTimeout(function() {
                $('.homepage .video-cover').trigger('click');
            }, 3000 );
        }

        $('.homepage .scroll-site').on('click', function () {
            var section = $(this).closest('.section').next();

            $('html, body').animate({
                scrollTop: section.offset().top
            }, 500);
        });

        //Slider quotes (CEO, managers)

        var homepageQuotesSwiper = new Swiper('.homepage .swiper-quotes', {
            slidesPerView: 'auto',
            loop: true,
            navigation: {
                nextEl: '.homepage .swiper-quotes .swiper-button-next',
                prevEl: '.homepage .swiper-quotes .swiper-button-prev',
            },
            breakpoints: {
                575: {
                    autoHeight: true,
                }
            }
        });

        $('.homepage .quotations-menu .quotation-author').on('click', function () {
            var quoteIndex = $(this).index();
            homepageQuotesSwiper.slideToLoop(quoteIndex);

            $(this).siblings().removeClass('active');
            $(this).addClass('active');
        });

        homepageQuotesSwiper.on('slideChange', function () {
            var quoteSlideIndex = homepageQuotesSwiper.realIndex;
            $('.homepage .quotations-menu .quotation-author').eq(quoteSlideIndex).siblings().removeClass('active');
            $('.homepage .quotations-menu .quotation-author').eq(quoteSlideIndex).addClass('active');
        });

        //Slider results - images

        var homepageResultsImagesSwiper = new Swiper('.homepage .swiper-results-images', {
            slidesPerView: 'auto',
            loop: true,
            direction: 'vertical',
            spaceBetween: 15,

            breakpoints: {
                767: {
                    allowTouchMove: false,
                }
            }
        });

        //Results tavs nav - click chabge slider image
        $('.homepage #tabs-results a').on('click', function () {
            var resultsTabIndex = $(this).parent().index();
            homepageResultsImagesSwiper.slideToLoop(resultsTabIndex);
        });

        //Slider results - big-numbers

        $('.homepage .swiper-results-big-numbers').each(function (index) {
            var homepageResultsBigNumbersSwiper = new Swiper($(this)[0], {
                slidesPerView: 1,
                direction: 'vertical',
                loop: true,
                spaceBetween: 150,
                observer: true,
                observeParents: true,
                navigation: {
                    nextEl: '.homepage .swiper-results-big-numbers .swiper-button-next',
                    prevEl: '.homepage .swiper-results-big-numbers .swiper-button-prev',
                },

                breakpoints: {
                    767: {
                        allowTouchMove: false,
                    }
                }
            });
        });

        //Slider responsibilities

        var homepageResponsibilitiesSwiper = new Swiper('.homepage .swiper-responsibilities', {
            slidesPerView: 'auto',
            loop: true,
            spaceBetween: 20,
            centeredSlides: true,
            navigation: {
                nextEl: '.homepage .swiper-responsibilities .swiper-button-next',
                prevEl: '.homepage .swiper-responsibilities .swiper-button-prev',
            },
        });

        $('.homepage .responsibilities-menu li a').on('click', function (e) {
            e.preventDefault();
            var responsibilityIndex = $(this).parent().index();
            homepageResponsibilitiesSwiper.slideToLoop(responsibilityIndex);

            $(this).parent().siblings().children('a').removeClass('active');
            $(this).addClass('active');
        });

        homepageResponsibilitiesSwiper.on('slideChange', function () {
            var responsibilitySlideIndex = homepageResponsibilitiesSwiper.realIndex;
            $('.homepage .responsibilities-menu li').eq(responsibilitySlideIndex).siblings().children('a').removeClass('active');
            $('.homepage .responsibilities-menu li').eq(responsibilitySlideIndex).children('a').addClass('active');
        });

        //Slider development

        var homepageDevelopmentSwiper = new Swiper('.homepage .swiper-development', {
            slidesPerView: 'auto',
            loop: true,
            direction: 'vertical',
            spaceBetween: 15,

            breakpoints: {
                767: {
                    allowTouchMove: false,
                }
            }
        });

        $('.homepage .development-menu li a').on('click', function (e) {
            e.preventDefault();
            var developmentIndex = $(this).parent().index();
            homepageDevelopmentSwiper.slideToLoop(developmentIndex);

            $(this).parent().siblings().children('a').removeClass('active');
            $(this).addClass('active');
        });

        homepageDevelopmentSwiper.on('slideChange', function () {
            var developmentSlideIndex = homepageDevelopmentSwiper.realIndex;
            $('.homepage .development-menu li').eq(developmentSlideIndex).siblings().children('a').removeClass('active');
            $('.homepage .development-menu li').eq(developmentSlideIndex).children('a').addClass('active');
        });

        //Development slide tabs

        $('.homepage .development-tabs-nav li').on('click', function (e) {
            e.preventDefault();
            $(this).addClass('active');
            $(this).siblings().removeClass('active');

            if (window.matchMedia("(min-width: 576px)").matches) {
                var developmentTabIndex = $(this).index();
                $(this).parent().siblings('.development-tabs').children('.development-tab').eq(developmentTabIndex).fadeIn();
                $(this).parent().siblings('.development-tabs').children('.development-tab').eq(developmentTabIndex).siblings('.development-tab').fadeOut();
            } else {
                $(this).children('.development-tab-mobile').slideDown();
                $(this).siblings().children('.development-tab-mobile').slideUp()
            }
        });

        //Development slide tabs - by prev, next buttons

        $('.homepage .development .swiper-button-prev').on('click', function () {
            var developmentTabActiveIndex = $('.homepage .swiper-development .swiper-slide-active .development-tabs-nav li.active').index();

            $('.homepage .swiper-development .swiper-slide-active .development-tabs-nav li').eq(developmentTabActiveIndex - 1).addClass('active');
            $('.homepage .swiper-development .swiper-slide-active .development-tabs-nav li').eq(developmentTabActiveIndex - 1).siblings().removeClass('active');

            $('.homepage .swiper-development .swiper-slide-active .development-tab').eq(developmentTabActiveIndex - 1).fadeIn();
            $('.homepage .swiper-development .swiper-slide-active .development-tab').eq(developmentTabActiveIndex - 1).siblings().fadeOut();
        });

        $('.homepage .development .swiper-button-next').on('click', function () {
            var developmentTabActiveIndex = $('.homepage .swiper-development .swiper-slide-active .development-tabs-nav li.active').index();

            var totalTabs = $('.homepage .swiper-development .swiper-slide-active .development-tabs-nav li').length;
            if (developmentTabActiveIndex === totalTabs - 1) {
                developmentTabActiveIndex = -1;
            }

            $('.homepage .swiper-development .swiper-slide-active .development-tabs-nav li').eq(developmentTabActiveIndex + 1).addClass('active');
            $('.homepage .swiper-development .swiper-slide-active .development-tabs-nav li').eq(developmentTabActiveIndex + 1).siblings().removeClass('active');

            $('.homepage .swiper-development .swiper-slide-active .development-tab').eq(developmentTabActiveIndex + 1).fadeIn();
            $('.homepage .swiper-development .swiper-slide-active .development-tab').eq(developmentTabActiveIndex + 1).siblings().fadeOut();
        });

        // Operate slide tabs
        $('.homepage .operate .nav-pills').on('show.bs.tab', function (e) {
            const targetTab = $(e.target);
            const targetBG = $(`[data-section-bg="${targetTab.data('target-bg')}"]`);

            $('.homepage .operate-backgrounds .background.active').removeClass('active');
            setTimeout(() => targetBG.addClass('active'), 200);
        })

    });
}(jQuery));
